const getBaseUrl = () => process.env.REACT_APP_API_URL || '';

/**
 * @param {File} file
 * @returns {Promise<{ filePath: string }>}
 */
export async function uploadVisuelPass(file) {
	const formData = new FormData();
	formData.append('visuel_pass_recto', file);
	const response = await fetch(`${getBaseUrl()}/api/upload`, {
		method: 'POST',
		body: formData,
	});
	if (!response.ok) {
		throw new Error("Échec de l'envoi du fichier.");
	}
	return response.json();
}

/**
 * @param {object} payload
 * @returns {Promise<Response>}
 */
export async function saveForm(payload) {
	return fetch(`${getBaseUrl()}/api/save-form`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(payload),
	});
}
